import React from 'react';
import AuditDashboard from '../../gestion-audit/AuditDashboard';

export default function AuditDashboardMobile() { return <AuditDashboard mobile />; }
